module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"buyQuota":"Buy","interviews":"candidates","sms":"SMS","calls":"calls","rules":"If you buy {type}, they are not burned at the beginning of the reporting period","quantity":"Quantity","payable":"Payable:"}}')
  delete Component.options._Ctor
}
